const STORAGE_KEY = 'lens_pending_sso_mfa';

/**
 * Persist MFA handoff so browser back from /authenticate does not lose location.state
 * (ephemeral_token, type, credentials for non-SSO flows).
 */
export function writePendingSsoMfaState(state) {
    if (!state?.ephemeral_token) {
        return;
    }
    try {
        sessionStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({
                ephemeral_token: state.ephemeral_token,
                type: state.type ?? '',
                email: state.email ?? '',
                password: state.password ?? '',
            }),
        );
    } catch {
        // ignore quota / private mode
    }
}

export function readPendingSsoMfaState() {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return null;
        }
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed.ephemeral_token !== 'string' || !parsed.ephemeral_token) {
            return null;
        }
        return {
            ephemeral_token: parsed.ephemeral_token,
            type: parsed.type,
            email: parsed.email,
            password: parsed.password,
        };
    } catch {
        return null;
    }
}

export function clearPendingSsoMfaState() {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch {
        // ignore
    }
}

export function hasPendingSsoMfaState() {
    return Boolean(readPendingSsoMfaState());
}
